// @owners { team: patient-health }
import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { createEvent } from '~shared/lib/analytics/src/helper';
import { connect } from '~shared/store';
import { type ReduxDispatchShared, type ReduxStateShared } from '~shared/types';
import MedListSearchResults from './MedListSearchResults';
import getMedicationSearchOptions from '~web/features/my-meds/selectors/getMedicationSearchOptions';

const mapStateToProps = (state: ReduxStateShared) => ({
  searchOptions: getMedicationSearchOptions(state),
});

const mapDispatchToProps = (dispatch: ReduxDispatchShared) => {
  return {
    fireMedicationsSearchedAnalyticsEvent: (searchTerm: string) => {
      dispatch(sendAnalyticsEvent(createEvent(EVENTS.MED_LIST__MEDICATIONS_SEARCHED, { searchTerm })));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MedListSearchResults);
